import { render, staticRenderFns } from "./RequestPayloadMapping.vue?vue&type=template&id=190aeb52"
import script from "./RequestPayloadMapping.vue?vue&type=script&lang=js"
export * from "./RequestPayloadMapping.vue?vue&type=script&lang=js"
import style0 from "./RequestPayloadMapping.vue?vue&type=style&index=0&id=190aeb52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports